import React from 'react';
import { Provider } from 'react-redux';
import store from '../../../state';

import DutyPlanner from './DutyPlanner';

// This is a wrapper class that allows placing the duty
// planner in any part of the website. To work properly,
// the following properties must be provided to the Duty
// Planner:
// - groupId
// - startTime, endTime (the initial display period)
// - defaultFunctionId (the function used to find candidates)
// - readOnly: Determines whether schedules can be modified from here

// NOTE: For this wrapper the properties must be explicitly passed from
// either a Parent Component, or directly from Ruby
const DutyPlannerStandalone = props => (
  <Provider store={store}>
    <DutyPlanner {...props} />
  </Provider>
);

export default DutyPlannerStandalone;
